import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
export function relationshipRowType(field: SchemaField): string {
  return isUserRelationshipTarget(field.relationship)
    ? '{ id?: string | null; name?: string | null; email?: string | null }'
    : '{ id?: string | null; name?: string | null; title?: string | null; slug?: string | null; label?: string | null }'
}
